import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboOperarioActivo`, method: 'GET', body: null, token: token})
}